<div class="height">
    <h2 class="text-center m-4" >Add Governrate </h2>


    <form action="post" class="text-center m-4">
        <label for="cat-name" > Enter Name Of The Governorate </label> <br> 
        <input class="" id="gov-name"  [(ngModel)]="val"  [ngModelOptions]="{standalone: true}" > <br>
        <button class="btn btn-primary " class=" btn btn-success mt-3"  (click)="addGov()"> Add</button>
    </form>

</div>